var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-skeleton-field-wrapper widget-field-container"},[_c('v-skeleton-loader',_vm._b({staticClass:"skeleton-field",attrs:{"type":_vm.skeletonType}},'v-skeleton-loader',_vm.loaderAttributes,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }